export const openWhatsAppChat = () => {
  const chatEvent = new CustomEvent('open-whatsapp-chat', {
    detail: {
      platform: 'whatsapp',
    },
  });

  window.dispatchEvent(chatEvent);
  return true;
};

export const openMessengerChat = () => {
  const chatEvent = new CustomEvent('open-messenger-chat', {
    detail: {
      platform: 'facebook',
    },
  });

  window.dispatchEvent(chatEvent);
  return true;
};

export const openInstagramChat = () => {
  const chatEvent = new CustomEvent('open-instagram-chat', {
    detail: {
      platform: 'instagram',
    },
  });

  window.dispatchEvent(chatEvent);
  return true;
};
